import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { SelectOption } from "@iddataweb/idw-common-ui/types";

export const LANGUAGE_SELECT_OPTIONS: Array<SelectOption<LocaleTypes>> = [
    {
        label: "Brazilian Portugese",
        value: LocaleTypes.BRAZILIAN_PORTUGESE
    },
    {
        label: "Dutch",
        value: LocaleTypes.DUTCH
    },
    {
        label: "English",
        value: LocaleTypes.ENGLISH
    },
    {
        label: "French",
        value: LocaleTypes.FRENCH
    },
    {
        label: "German",
        value: LocaleTypes.GERMAN
    },
    {
        label: "Hmong",
        value: LocaleTypes.HMONG
    },
    {
        label: "Italian",
        value: LocaleTypes.ITALIAN
    },
    {
        label: "Portugese",
        value: LocaleTypes.PORTUGESE
    },
    {
        label: "Somali",
        value: LocaleTypes.SOMALI
    },
    {
        label: "Spanish",
        value: LocaleTypes.SPANISH
    },
    {
        label: "Swedish",
        value: LocaleTypes.SWEDISH
    },
    {
        label: "Vietnamese",
        value: LocaleTypes.VIETNAMESE
    }
];